import React, { useState, useEffect } from "react";
import "../../ViewInfo.css";
import { TextField, Button, MenuItem, Menu } from "@mui/material";
import { Get_One_Nested_Prop_From_MongoDB } from "../../../api/Get_One_Nested_Prop_From_MongoDB";
import { useParams } from "react-router-dom";
import { Update_To_MongoDB_By_ID } from "../../../api/Update_To_MongoDB_By_ID";
import removeUnderscores from "../../../../functions/removeUnderscores";
import { StudentuseAuth } from "../../../security/StudentUseAuth";
import { Student_Get_One_Nested_Prop_From_MongoDB } from "../../../api/Student_Get_One_Nested_Prop_From_MongoDB";
import { Student_Update_To_MongoDB_By_ID } from "../../../api/Student_Update_To_MongoDB_By_ID";
import { Link } from "react-router-dom";
import WEFChangePage from "../../../components/ChangePage/WEFChangePage";

function ViewEmergancyMedicalInfo() {
  const { id } = useParams();
  const { logoutStudent } = StudentuseAuth();

  const [formEmergancyMedicalInfo, setformEmergancyMedicalInfo] = useState({
    Emergancy_Medical_Allergies: "",
    Emergancy_Medical_Allergies_What_Is_It: "",
    Emergancy_Medical_Allergies_How_To_Deal_With_It: "",
    Emergancy_Medical_Medicine_EpiPen: "",
    Emergancy_Medical_Medicine_Inhaler: "",
    Emergancy_Medical_Medicine_Other: "",
    Emergancy_Medical_Medicine_Other_Further_Info: "",
    Emergancy_Medical_Medical_Conditions: "",
    Emergancy_Medical_Medical_Condition_What: "",
    Emergancy_Medical_Medical_Condition_Further_Info: "",
  });

  const [SEFProgress, setSEFProgress] = useState({
    EmergancyMedicalInfo: "",
  });

  useEffect(() => {
    Student_Get_One_Nested_Prop_From_MongoDB(
      "Registers_2025",
      "All",
      localStorage.getItem("Student_id"),
      "SEFEmergancyMedicalInfo",
      setformEmergancyMedicalInfo,
      logoutStudent
    );
    Student_Get_One_Nested_Prop_From_MongoDB(
      "Registers_2025",
      "All",
      localStorage.getItem("Student_id"),
      "SEFProgress",
      setSEFProgress,
      logoutStudent
    );
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setformEmergancyMedicalInfo((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const [status, setStatus] = useState(false);

  const handleSaveProgress = () => {
    Student_Update_To_MongoDB_By_ID(
      {
        SEFEmergancyMedicalInfo: formEmergancyMedicalInfo,
        "SEFProgress.EmergancyMedicalInfo": "In_Progress",
      },
      "Registers_2025",
      "All",
      setStatus,
      localStorage.getItem("Student_id"),
      "Your progress has been saved, you may now navigate to another page using the buttons at the bottom or close this tab",
      logoutStudent
    );
    setPageButtonStatus(true);
  };

  const handleSubmit = () => {
    Student_Update_To_MongoDB_By_ID(
      {
        SEFEmergancyMedicalInfo: formEmergancyMedicalInfo,
        //SEFProgress: { EmergancyMedicalInfo: "Complete" },
        "SEFProgress.EmergancyMedicalInfo": "Complete",
      },
      "Registers_2025",
      "All",
      setStatus,
      localStorage.getItem("Student_id"),
      "This page has been submitted, you may now navigate to another page using the buttons at the bottom or close this tab",
      logoutStudent
    );
    setSEFProgress({
      EmergancyMedicalInfo: "Complete",
    });
    setPageButtonStatus(true);
  };

  const isFormComplete =
    formEmergancyMedicalInfo &&
    (formEmergancyMedicalInfo.Emergancy_Medical_Allergies === "No" ||
      (formEmergancyMedicalInfo.Emergancy_Medical_Allergies_What_Is_It &&
        formEmergancyMedicalInfo.Emergancy_Medical_Allergies_How_To_Deal_With_It)) &&
    formEmergancyMedicalInfo.Emergancy_Medical_Medicine_EpiPen &&
    formEmergancyMedicalInfo.Emergancy_Medical_Medicine_Inhaler &&
    (formEmergancyMedicalInfo.Emergancy_Medical_Medicine_Other === "No" ||
      formEmergancyMedicalInfo.Emergancy_Medical_Medicine_Other_Further_Info) &&
    (formEmergancyMedicalInfo.Emergancy_Medical_Medical_Conditions === "No" ||
      (formEmergancyMedicalInfo.Emergancy_Medical_Medical_Condition_What &&
        formEmergancyMedicalInfo.Emergancy_Medical_Medical_Condition_Further_Info));

  const [PageButtonStatus, setPageButtonStatus] = useState(false);

  return (
    <div className="view-basic-info-container">
      <h1>Emergency Medical Information</h1>
      {SEFProgress &&
      SEFProgress.EmergancyMedicalInfo &&
      (SEFProgress.EmergancyMedicalInfo === "Complete" ||
        SEFProgress.EmergancyMedicalInfo === "Awaiting_Review") ? (
        <strong>
          If you need to make further changes, please contact InvestIN at
          info@investin.org or speak to your known contact
        </strong>
      ) : (
        ""
      )}

      <form className="view-basic-info-form">
        Does the student have any allergies that would require life-saving
        treatment if triggered? (e.g. Food allergens such as nuts, or medical
        equipment such as latex). Please be aware that we do not provide
        refreshments, but students may bring food with them from home. As a
        result, we are unable to enrol students with airborne food allergies.
        <TextField
          label={removeUnderscores("Emergency_medical_allergies")}
          variant="outlined"
          fullWidth
          required
          name="Emergancy_Medical_Allergies"
          value={formEmergancyMedicalInfo?.Emergancy_Medical_Allergies}
          onChange={handleChange}
          InputProps={{
            style: {
              backgroundColor: "white",
              textAlign: "left",
              color: "black", // Set the font color to black
            },
          }}
          InputLabelProps={{
            style: {
              fontSize: "1.2rem", // Increase the font size of the label
              color: "black", // Set the label color to black
            },
          }}
          select
        >
          <MenuItem value="">-----</MenuItem>
          <MenuItem value="Yes">Yes</MenuItem>
          <MenuItem value="No">No</MenuItem>
        </TextField>
        {formEmergancyMedicalInfo?.Emergancy_Medical_Allergies === "Yes" ? (
          <>
            <TextField
              label={removeUnderscores(
                "What is the student allergic to? (e.g. peanuts):"
              )}
              variant="outlined"
              fullWidth
              required
              name="Emergancy_Medical_Allergies_What_Is_It"
              value={
                formEmergancyMedicalInfo?.Emergancy_Medical_Allergies_What_Is_It
              }
              onChange={handleChange}
              InputProps={{
                style: {
                  backgroundColor: "white",
                  textAlign: "left",
                  color: "black", // Set the font color to black
                },
              }}
              InputLabelProps={{
                style: {
                  fontSize: "1.2rem", // Increase the font size of the label
                  color: "black", // Set the label color to black
                },
              }}
            />
            How should we deal with the allergic reaction in the unlikely event
            that the student interacts with an allergen? (e.g. call 111/ call
            parents/ call 999 immediately)
            <TextField
              label={removeUnderscores(
                "How should we deal with the allergic reaction?"
              )}
              variant="outlined"
              fullWidth
              required
              name="Emergancy_Medical_Allergies_How_To_Deal_With_It"
              value={
                formEmergancyMedicalInfo?.Emergancy_Medical_Allergies_How_To_Deal_With_It
              }
              onChange={handleChange}
              InputProps={{
                style: {
                  backgroundColor: "white",
                  textAlign: "left",
                  color: "black", // Set the font color to black
                },
              }}
              InputLabelProps={{
                style: {
                  fontSize: "1.2rem", // Increase the font size of the label
                  color: "black", // Set the label color to black
                },
              }}
            />
          </>
        ) : (
          <></>
        )}
        Please note that where students have life-saving medication prescribed
        to them (e.g. an inhaler/EpiPen), they must bring it with them to the
        programme. Will the student be bringing any life-saving medications with
        them?
        <TextField
          label={removeUnderscores("EpiPen")}
          variant="outlined"
          fullWidth
          required
          name="Emergancy_Medical_Medicine_EpiPen"
          value={formEmergancyMedicalInfo?.Emergancy_Medical_Medicine_EpiPen}
          onChange={handleChange}
          InputProps={{
            style: {
              backgroundColor: "white",
              textAlign: "left",
              color: "black", // Set the font color to black
            },
          }}
          InputLabelProps={{
            style: {
              fontSize: "1.2rem", // Increase the font size of the label
              color: "black", // Set the label color to black
            },
          }}
          select
        >
          <MenuItem value="">-----</MenuItem>
          <MenuItem value="Yes">Yes</MenuItem>
          <MenuItem value="No">No</MenuItem>
        </TextField>
        <TextField
          label={removeUnderscores("Inhaler")}
          variant="outlined"
          fullWidth
          required
          name="Emergancy_Medical_Medicine_Inhaler"
          value={formEmergancyMedicalInfo?.Emergancy_Medical_Medicine_Inhaler}
          onChange={handleChange}
          InputProps={{
            style: {
              backgroundColor: "white",
              textAlign: "left",
              color: "black", // Set the font color to black
            },
          }}
          InputLabelProps={{
            style: {
              fontSize: "1.2rem", // Increase the font size of the label
              color: "black", // Set the label color to black
            },
          }}
          select
        >
          <MenuItem value="">-----</MenuItem>
          <MenuItem value="Yes">Yes</MenuItem>
          <MenuItem value="No">No</MenuItem>
        </TextField>
        <TextField
          label={removeUnderscores("Other")}
          variant="outlined"
          fullWidth
          required
          name="Emergancy_Medical_Medicine_Other"
          value={formEmergancyMedicalInfo?.Emergancy_Medical_Medicine_Other}
          onChange={handleChange}
          InputProps={{
            style: {
              backgroundColor: "white",
              textAlign: "left",
              color: "black", // Set the font color to black
            },
          }}
          InputLabelProps={{
            style: {
              fontSize: "1.2rem", // Increase the font size of the label
              color: "black", // Set the label color to black
            },
          }}
          select
        >
          <MenuItem value="">-----</MenuItem>
          <MenuItem value="Yes">Yes</MenuItem>
          <MenuItem value="No">No</MenuItem>
        </TextField>
        {formEmergancyMedicalInfo?.Emergancy_Medical_Medicine_Other ===
        "Yes" ? (
          <>
            <TextField
              label={removeUnderscores(
                "Please provide more information on the 'other' medication"
              )}
              variant="outlined"
              fullWidth
              required
              name="Emergancy_Medical_Medicine_Other_Further_Info"
              value={
                formEmergancyMedicalInfo?.Emergancy_Medical_Medicine_Other_Further_Info
              }
              onChange={handleChange}
              InputProps={{
                style: {
                  backgroundColor: "white",
                  textAlign: "left",
                  color: "black", // Set the font color to black
                },
              }}
              InputLabelProps={{
                style: {
                  fontSize: "1.2rem", // Increase the font size of the label
                  color: "black", // Set the label color to black
                },
              }}
            />
          </>
        ) : (
          <></>
        )}
        Does the student have any other known medical conditions that we need to
        be aware of for the duration of this one-day programme where emergency
        or life saving treatment could be required? (e.g. epilepsy, diabetes or
        any other serious health condition)
        <TextField
          label={removeUnderscores("Medical_conditions")}
          variant="outlined"
          fullWidth
          required
          name="Emergancy_Medical_Medical_Conditions"
          value={formEmergancyMedicalInfo?.Emergancy_Medical_Medical_Conditions}
          onChange={handleChange}
          InputProps={{
            style: {
              backgroundColor: "white",
              textAlign: "left",
              color: "black", // Set the font color to black
            },
          }}
          InputLabelProps={{
            style: {
              fontSize: "1.2rem", // Increase the font size of the label
              color: "black", // Set the label color to black
            },
          }}
          select
        >
          <MenuItem value="">-----</MenuItem>
          <MenuItem value="Yes">Yes</MenuItem>
          <MenuItem value="No">No</MenuItem>
        </TextField>
        {formEmergancyMedicalInfo?.Emergancy_Medical_Medical_Conditions ===
        "Yes" ? (
          <>
            Please provide detailed information below for each specific
            medication condition to ensure we have all the necessary information
            required to keep the student safe during their programme.
            <TextField
              label={removeUnderscores("What is the medical condition?")}
              variant="outlined"
              fullWidth
              required
              name="Emergancy_Medical_Medical_Condition_What"
              value={
                formEmergancyMedicalInfo?.Emergancy_Medical_Medical_Condition_What
              }
              onChange={handleChange}
              InputProps={{
                style: {
                  backgroundColor: "white",
                  textAlign: "left",
                  color: "black", // Set the font color to black
                },
              }}
              InputLabelProps={{
                style: {
                  fontSize: "1.2rem", // Increase the font size of the label
                  color: "black", // Set the label color to black
                },
              }}
            />
            Please provide further information on anything you think we should
            know about how to assist if this medical condition is triggered
            during the programme
            <TextField
              label={removeUnderscores(
                "Further information on this medical condition"
              )}
              variant="outlined"
              fullWidth
              required
              name="Emergancy_Medical_Medical_Condition_Further_Info"
              value={
                formEmergancyMedicalInfo?.Emergancy_Medical_Medical_Condition_Further_Info
              }
              onChange={handleChange}
              InputProps={{
                style: {
                  backgroundColor: "white",
                  textAlign: "left",
                  color: "black", // Set the font color to black
                },
              }}
              InputLabelProps={{
                style: {
                  fontSize: "1.2rem", // Increase the font size of the label
                  color: "black", // Set the label color to black
                },
              }}
            />
          </>
        ) : (
          <></>
        )}
        <WEFChangePage
          Page={"EmergancyMedicalInfo"}
          PageButtonStatus={PageButtonStatus}
        />
        <div className="view-basic-info-buttons">
          <Button
            variant="contained"
            color="primary"
            onClick={handleSaveProgress}
            disabled={
              status ||
              (SEFProgress &&
                SEFProgress.EmergancyMedicalInfo &&
                (SEFProgress.EmergancyMedicalInfo === "Complete" ||
                  SEFProgress.EmergancyMedicalInfo === "Awaiting_Review"))
            }
          >
            Save Progress
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={handleSubmit}
            disabled={
              !isFormComplete ||
              status ||
              (SEFProgress &&
                SEFProgress.EmergancyMedicalInfo &&
                (SEFProgress.EmergancyMedicalInfo === "Complete" ||
                  SEFProgress.EmergancyMedicalInfo === "Awaiting_Review"))
            }
          >
            Submit
          </Button>
        </div>
      </form>
    </div>
  );
}

export default ViewEmergancyMedicalInfo;
